"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _core = require("@material-ui/core");

var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));

var _Help = _interopRequireDefault(require("@material-ui/icons/Help"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AppStore = _interopRequireDefault(require("../../Store/AppStore"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      maxWidth: 550,
      padding: theme.spacing(2)
    },
    fullWidth: {
      width: "100%"
    },
    halfWidth: {
      width: "50%"
    },
    defaultCard: {
      marginRight: theme.spacing(-1)
    },
    popover: {
      padding: theme.spacing(2),
      width: 300
    }
  };
});

var TSEPFields = function TSEPFields(_ref) {
  var cardStore = _ref.cardStore,
      cardElem = _ref.cardElem,
      clearCardNumberError = _ref.clearCardNumberError,
      cardNumberError = _ref.cardNumberError,
      expElem = _ref.expElem,
      clearExpirationError = _ref.clearExpirationError,
      expirationError = _ref.expirationError,
      cvvElem = _ref.cvvElem,
      clearCvvError = _ref.clearCvvError,
      cvvError = _ref.cvvError,
      tsepNeedsLoaded = _ref.tsepNeedsLoaded;
  var classes = useStyles();
  var history = (0, _reactRouterDom.useHistory)();

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      popoverAnchor = _useState2[0],
      setPopoverAnchor = _useState2[1];

  var tokenSaved = Boolean(cardStore.token && cardStore.token.length > 0);
  (0, _react.useEffect)(function () {
    if (tsepNeedsLoaded) {
      var initTSEPFieldsEvent = new CustomEvent("initialize-form", {
        detail: {
          manifestURL: _AppStore.default.manifest
        }
      });
      document.dispatchEvent(initTSEPFieldsEvent);

      _AppStore.default.tsepScriptsLoaded();
    }
  }, [tsepNeedsLoaded]);
  (0, _react.useEffect)(function () {
    var handleErrorEvent = function handleErrorEvent(event) {
      _AppStore.default.setError(event.detail.message);
    };

    document.addEventListener("error-message", handleErrorEvent);
    return function () {
      document.removeEventListener("error-message", handleErrorEvent);
    };
  }, []);

  if (!_AppStore.default.selectedAccount || !_AppStore.default.paymentAmount) {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
      to: "/accountSelect"
    });
  }

  if (tsepNeedsLoaded) {
    return /*#__PURE__*/_react.default.createElement(_core.Backdrop, {
      open: true
    }, /*#__PURE__*/_react.default.createElement(_core.CircularProgress, {
      size: 100
    }));
  }

  if (_AppStore.default.error) {
    var startOver = function startOver() {
      _AppStore.default.reload();

      history.push("/");
    };

    return /*#__PURE__*/_react.default.createElement(_core.Dialog, {
      open: true,
      onClose: startOver
    }, /*#__PURE__*/_react.default.createElement(_core.DialogTitle, null, "Error Communicating with Server"), /*#__PURE__*/_react.default.createElement(_core.DialogContent, null, /*#__PURE__*/_react.default.createElement(_core.DialogContentText, null, _AppStore.default.error)), /*#__PURE__*/_react.default.createElement(_core.DialogActions, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
      onClick: startOver,
      autoFocus: true,
      variant: "contained"
    }, "Start Over")));
  }

  var goBack = function goBack() {
    _AppStore.default.reloadTSEPScripts();

    history.push("/");
  };

  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    direction: "column",
    className: classes.root,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    variant: "outlined",
    label: "Card Number",
    fullWidth: true,
    required: true,
    disabled: tokenSaved,
    inputRef: cardElem,
    InputProps: {
      id: "tsep-cardNum"
    },
    onBlur: clearCardNumberError,
    helperText: cardNumberError,
    error: cardNumberError.length > 0
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    spacing: 2,
    justify: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    className: classes.halfWidth
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    fullWidth: true,
    label: "CVV",
    variant: "outlined",
    required: true,
    disabled: tokenSaved,
    inputRef: cvvElem,
    InputProps: {
      id: "tsep-cvv2"
    },
    onBlur: clearCvvError,
    helperText: cvvError,
    error: cvvError.length > 0
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    className: classes.halfWidth
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    fullWidth: true,
    label: "Expiration Date",
    variant: "outlined",
    required: true,
    inputRef: expElem,
    disabled: tokenSaved,
    InputProps: {
      id: "tsep-datepicker"
    },
    onBlur: clearExpirationError,
    helperText: expirationError,
    error: expirationError.length > 0
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    container: true,
    direction: "row",
    justify: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      checked: cardStore.shouldSave,
      onChange: cardStore.shouldSaveChecked
    }),
    label: "Save Card Information"
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Hidden, {
    xsUp: !cardStore.shouldSave
  }, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    style: {
      marginRight: 0
    },
    control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      checked: cardStore.saveAsDefault,
      onChange: cardStore.saveAsDefaultChecked
    }),
    label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Set as Default Card", " ", /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      edge: "end",
      onClick: function onClick(e) {
        return setPopoverAnchor(e.currentTarget);
      }
    }, /*#__PURE__*/_react.default.createElement(_Help.default, null)))
  }), /*#__PURE__*/_react.default.createElement(_core.Popover, {
    open: Boolean(popoverAnchor),
    anchorEl: popoverAnchor,
    onClose: function onClose() {
      return setPopoverAnchor(null);
    },
    anchorOrigin: {
      vertical: "center",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "center",
      horizontal: "right"
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.popover
  }, "The default card is the card that is automatically selected when making a new payment.", /*#__PURE__*/_react.default.createElement("br", null), "A different card can be selected when making a payment, if desired."))))), /*#__PURE__*/_react.default.createElement(_core.Hidden, {
    xsUp: !cardStore.shouldSave
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    variant: "outlined",
    label: "Card Nickname (Optional)",
    fullWidth: true,
    value: cardStore.nickname,
    onChange: function onChange(e) {
      return cardStore.setNickname(e.target.value);
    }
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.fullWidth,
    variant: "outlined",
    color: "primary",
    startIcon: /*#__PURE__*/_react.default.createElement(_ArrowBack.default, null),
    onClick: goBack
  }, "Go Back")), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.fullWidth,
    variant: "contained",
    color: "primary" //Enable next page button if a token has been generated
    ,
    disabled: !cardStore.token,
    component: _reactRouterDom.Link,
    to: "/cardholder"
  }, "Next")));
};

TSEPFields.propTypes = {
  cardStore: _propTypes.default.shape({
    nickname: _propTypes.default.string,
    setNickname: _propTypes.default.func.isRequired,
    token: _propTypes.default.string,
    cvv: _propTypes.default.string,
    expiration: _propTypes.default.string,
    cardType: _propTypes.default.string,
    shouldSave: _propTypes.default.bool,
    shouldSaveChecked: _propTypes.default.func.isRequired,
    saveAsDefault: _propTypes.default.bool,
    saveAsDefaultChecked: _propTypes.default.func.isRequired
  }).isRequired,
  cardElem: _propTypes.default.object.isRequired,
  cvvElem: _propTypes.default.object.isRequired,
  expElem: _propTypes.default.object.isRequired,
  cardNumberError: _propTypes.default.string.isRequired,
  expirationError: _propTypes.default.string.isRequired,
  cvvError: _propTypes.default.string.isRequired,
  clearCardNumberError: _propTypes.default.func.isRequired,
  clearExpirationError: _propTypes.default.func.isRequired,
  clearCvvError: _propTypes.default.func.isRequired,
  tsepNeedsLoaded: _propTypes.default.bool.isRequired
};

var _default = (0, _mobxReact.observer)(TSEPFields);

exports.default = _default;